import { createTranslations } from '../../../i18n/types';

export default createTranslations({
  en: {
    homeTitle: 'RushMid raffle',
    emptyTitle: 'No raffles today',
    rulesButton: 'Rules',
    ticketBadgeLabel: 'Entry',
    yourTicketsLabel: 'Your tickets',
    participantsLabelTop: 'Playing',
    playersOne: 'player',
    playersFew: 'players',
    playersMany: 'players',
    playCta: 'Play',

    detailTitle: 'Raffle',
    backButton: 'Back',
    totalPrizeLabel: 'Total prize',
    totalTicketsLabel: 'Total tickets',
    participantsStatLabel: 'Participants',
    chanceLabel: 'Your win chance',
    participantsSectionTitle: 'Participants',
    participantOne: 'participant',
    participantFew: 'participants',
    participantMany: 'participants',
    showMoreParticipants: 'Show more participants',
    noParticipantsYet: 'No participants yet',

    winnersTitle: 'Winners',
    winnersEmpty: 'No winners yet',
    pastWinnersButton: 'Past winners',

    rulesTitle: 'Raffle rules',
    ruleRowWin: 'Win',
    ruleRowMvp: 'Match MVP',
    ruleRowTriple: '3 kills',
    ruleRowQuad: '4 kills',
    ruleRowAce: '5 kills',
    ruleRowOneHp: 'Win at 1 HP',
    ruleRowClutch2: 'Clutch 1v2',
    ruleRowClutch3: 'Clutch 1v3',
    ruleWinsOnlyTitle: 'Wins only',
    ruleWinsOnlyDescription: 'Tickets are earned only for wins. Matches against bots never award tickets.',
    ruleBurnTitle: 'New raffle every day',
    ruleBurnDescription: 'The winner is drawn at midnight Moscow time, and a fresh raffle starts — tickets only count on the day you earn them.',
    ruleOneChanceTitle: 'More tickets — better odds',
    ruleOneChanceDescription: 'Every ticket is one chance in its entry tier raffle — the more tickets you collect in a day, the higher your odds of taking the prize.',
  },
  ru: {
    homeTitle: 'Розыгрыш RushMid',
    emptyTitle: 'Сегодня розыгрышей нет',
    rulesButton: 'Правила',
    ticketBadgeLabel: 'Вход',
    yourTicketsLabel: 'Твои билеты',
    participantsLabelTop: 'Участвует',
    playersOne: 'игрок',
    playersFew: 'игрока',
    playersMany: 'игроков',
    playCta: 'Играть',

    detailTitle: 'Розыгрыш',
    backButton: 'Назад',
    totalPrizeLabel: 'Общий приз',
    totalTicketsLabel: 'Всего билетов',
    participantsStatLabel: 'Участников',
    chanceLabel: 'Твой шанс на победу',
    participantsSectionTitle: 'Участники',
    participantOne: 'участник',
    participantFew: 'участника',
    participantMany: 'участников',
    showMoreParticipants: 'Показать ещё участников',
    noParticipantsYet: 'Пока никто не участвует',

    winnersTitle: 'Победители',
    winnersEmpty: 'Победителей пока нет',
    pastWinnersButton: 'Прошлые победители',

    rulesTitle: 'Правила розыгрыша',
    ruleRowWin: 'Победа',
    ruleRowMvp: 'MVP матча',
    ruleRowTriple: '3 кила',
    ruleRowQuad: '4 кила',
    ruleRowAce: '5 килов',
    ruleRowOneHp: 'Победа с 1 HP',
    ruleRowClutch2: 'Клатч 1v2',
    ruleRowClutch3: 'Клатч 1v3',
    ruleWinsOnlyTitle: 'Только победы',
    ruleWinsOnlyDescription: 'Билеты даются только за победы. За игру с ботами билеты не даются.',
    ruleBurnTitle: 'Каждый день — новый розыгрыш',
    ruleBurnDescription: 'В полночь по Москве определяется победитель и стартует новый розыгрыш — билеты действуют только в день, когда ты их получил.',
    ruleOneChanceTitle: 'Больше билетов — выше шанс',
    ruleOneChanceDescription: 'Каждый билет — один шанс в розыгрыше своего входа: чем больше билетов соберёшь за день, тем выше шанс забрать приз.',
  },
  uz: {
    homeTitle: 'RushMid yutuq oʻyini',
    emptyTitle: 'Bugun yutuq oʻyinlari yoʻq',
    rulesButton: 'Qoidalar',
    ticketBadgeLabel: 'Kirish',
    yourTicketsLabel: 'Biletlaring',
    participantsLabelTop: 'Ishtirokchi',
    playersOne: 'oʻyinchi',
    playersFew: 'oʻyinchi',
    playersMany: 'oʻyinchi',
    playCta: 'Oʻynash',

    detailTitle: 'Yutuq oʻyini',
    backButton: 'Orqaga',
    totalPrizeLabel: 'Umumiy yutuq',
    totalTicketsLabel: 'Jami biletlar',
    participantsStatLabel: 'Ishtirokchilar',
    chanceLabel: 'Gʻalaba imkoniyating',
    participantsSectionTitle: 'Ishtirokchilar',
    participantOne: 'ishtirokchi',
    participantFew: 'ishtirokchi',
    participantMany: 'ishtirokchi',
    showMoreParticipants: 'Koʻproq ishtirokchilarni koʻrsatish',
    noParticipantsYet: 'Hozircha hech kim ishtirok etmayapti',

    winnersTitle: 'Gʻoliblar',
    winnersEmpty: 'Hozircha gʻoliblar yoʻq',
    pastWinnersButton: 'Oldingi gʻoliblar',

    rulesTitle: 'Yutuq oʻyini qoidalari',
    ruleRowWin: 'Gʻalaba',
    ruleRowMvp: 'Match MVP',
    ruleRowTriple: '3 ta kill',
    ruleRowQuad: '4 ta kill',
    ruleRowAce: '5 ta kill',
    ruleRowOneHp: '1 HP bilan gʻalaba',
    ruleRowClutch2: 'Clutch 1v2',
    ruleRowClutch3: 'Clutch 1v3',
    ruleWinsOnlyTitle: 'Faqat gʻalabalar',
    ruleWinsOnlyDescription: 'Biletlar faqat gʻalabalar uchun beriladi. Botlarga qarshi oʻyin uchun bilet berilmaydi.',
    ruleBurnTitle: 'Har kuni yangi yutuq oʻyini',
    ruleBurnDescription: 'Moskva vaqti bilan yarim tunda gʻolib aniqlanadi va yangi oʻyin boshlanadi — biletlar faqat olingan kunida amal qiladi.',
    ruleOneChanceTitle: 'Bilet koʻp — imkoniyat yuqori',
    ruleOneChanceDescription: 'Har bir bilet oʻz kirish darajasida bitta imkoniyat beradi — kun davomida bilet qancha koʻp boʻlsa, yutish imkoniyati shuncha yuqori.',
  },
  fa: {
    homeTitle: 'قرعه‌کشی RushMid',
    emptyTitle: 'امروز قرعه‌کشی نیست',
    rulesButton: 'قوانین',
    ticketBadgeLabel: 'ورودی',
    yourTicketsLabel: 'بلیت‌های تو',
    participantsLabelTop: 'در حال بازی',
    playersOne: 'بازیکن',
    playersFew: 'بازیکن',
    playersMany: 'بازیکن',
    playCta: 'بازی کن',

    detailTitle: 'قرعه‌کشی',
    backButton: 'برگرد',
    totalPrizeLabel: 'کل جایزه',
    totalTicketsLabel: 'کل بلیت‌ها',
    participantsStatLabel: 'شرکت‌کنندگان',
    chanceLabel: 'شانس بردت',
    participantsSectionTitle: 'شرکت‌کنندگان',
    participantOne: 'شرکت‌کننده',
    participantFew: 'شرکت‌کننده',
    participantMany: 'شرکت‌کننده',
    showMoreParticipants: 'شرکت‌کنندگان بیشتر',
    noParticipantsYet: 'هنوز شرکت‌کننده‌ای نیست',

    winnersTitle: 'برندگان',
    winnersEmpty: 'هنوز برنده‌ای نیست',
    pastWinnersButton: 'برندگان قبلی',

    rulesTitle: 'قوانین قرعه‌کشی',
    ruleRowWin: 'برد',
    ruleRowMvp: 'MVP مسابقه',
    ruleRowTriple: '3 کیل',
    ruleRowQuad: '4 کیل',
    ruleRowAce: '5 کیل',
    ruleRowOneHp: 'برد با 1 HP',
    ruleRowClutch2: 'کلاچ 1v2',
    ruleRowClutch3: 'کلاچ 1v3',
    ruleWinsOnlyTitle: 'فقط برد',
    ruleWinsOnlyDescription: 'بلیت فقط با برد به دست می‌آید. مسابقه با بات هیچ بلیتی نمی‌دهد.',
    ruleBurnTitle: 'هر روز قرعه‌کشی تازه',
    ruleBurnDescription:
      'برنده نیمه‌شب به وقت مسکو انتخاب می‌شود و قرعه‌کشی تازه شروع می‌شود — بلیت‌ها فقط همان روزی که می‌گیری حساب می‌شوند.',
    ruleOneChanceTitle: 'بلیت بیشتر — شانس بیشتر',
    ruleOneChanceDescription:
      'هر بلیت یک شانس در قرعه‌کشی سطح ورودی خودش است — هرچه در یک روز بلیت بیشتری جمع کنی، شانس بردنت بیشتر می‌شود.',
  },
});
